import { render } from "./CountGame.vue?vue&type=template&id=561537ee&scoped=true"
import script from "./CountGame.vue?vue&type=script&lang=ts"
export * from "./CountGame.vue?vue&type=script&lang=ts"

import "./CountGame.vue?vue&type=style&index=0&id=561537ee&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-561537ee"

export default script